__turbopack_context__.v({
  "blueBackground": "MembershipSummary-module__Gt0Cwq__blueBackground",
  "container": "MembershipSummary-module__Gt0Cwq__container",
  "continueButton": "MembershipSummary-module__Gt0Cwq__continueButton",
  "costHeadline": "MembershipSummary-module__Gt0Cwq__costHeadline",
  "costSummary": "MembershipSummary-module__Gt0Cwq__costSummary",
  "discountColour": "MembershipSummary-module__Gt0Cwq__discountColour",
  "discountHeadline": "MembershipSummary-module__Gt0Cwq__discountHeadline",
  "discountMessage": "MembershipSummary-module__Gt0Cwq__discountMessage",
  "discountMessageContainer": "MembershipSummary-module__Gt0Cwq__discountMessageContainer",
  "discountMessageReferral": "MembershipSummary-module__Gt0Cwq__discountMessageReferral",
  "errorMessage": "MembershipSummary-module__Gt0Cwq__errorMessage",
  "formPromoCode": "MembershipSummary-module__Gt0Cwq__formPromoCode",
  "header": "MembershipSummary-module__Gt0Cwq__header",
  "headerRight": "MembershipSummary-module__Gt0Cwq__headerRight",
  "hidePromoForm": "MembershipSummary-module__Gt0Cwq__hidePromoForm",
  "hideSummaryItems": "MembershipSummary-module__Gt0Cwq__hideSummaryItems",
  "infoGraphic": "MembershipSummary-module__Gt0Cwq__infoGraphic",
  "infoGraphicContainer": "MembershipSummary-module__Gt0Cwq__infoGraphicContainer",
  "mascot": "MembershipSummary-module__Gt0Cwq__mascot",
  "membershipSummary": "MembershipSummary-module__Gt0Cwq__membershipSummary",
  "price": "MembershipSummary-module__Gt0Cwq__price",
  "promoActions": "MembershipSummary-module__Gt0Cwq__promoActions",
  "promoCodeButton": "MembershipSummary-module__Gt0Cwq__promoCodeButton",
  "promoCodeIcon": "MembershipSummary-module__Gt0Cwq__promoCodeIcon",
  "promoCodeIsSet": "MembershipSummary-module__Gt0Cwq__promoCodeIsSet",
  "promoSection": "MembershipSummary-module__Gt0Cwq__promoSection",
  "reverseChevron": "MembershipSummary-module__Gt0Cwq__reverseChevron",
  "showPromoForm": "MembershipSummary-module__Gt0Cwq__showPromoForm",
  "showSummaryItemsToggle": "MembershipSummary-module__Gt0Cwq__showSummaryItemsToggle",
  "summaryItem": "MembershipSummary-module__Gt0Cwq__summaryItem",
  "summaryItems": "MembershipSummary-module__Gt0Cwq__summaryItems",
  "tickWrapper": "MembershipSummary-module__Gt0Cwq__tickWrapper",
  "trustpilot": "MembershipSummary-module__Gt0Cwq__trustpilot",
});
